import { THttpService } from '@/services/HttpService';

import { TProductConfigResponse, TProductResponse } from './types';

export const formatSuccess = (data: TProductConfigResponse) => {
  const res = {
    bancodobrasil: {
      linkRedirect: data.linkRedirectBB,
      linkRedirectConfigApi: data.linkRedirectConfigApiBB,
      keyConfigApi: data.keyConfigApiBB === 'true',
    },
    santander: {
      linkRedirect: data.linkRedirectSantander,
      linkRedirectConfigApi: data.linkRedirectConfigApiSantander,
      keyConfigApi: data.keyConfigApiSantander === 'true',
    },
    bradesco: {
      linkRedirect: data.linkRedirectBradesco,
      linkRedirectConfigApi: data.linkRedirectConfigApiBradesco,
      keyConfigApi: data.keyConfigApiBradesco === 'true',
    },
  };
  return res;
};

export const getProdConfigData = async (
  api: THttpService,
): Promise<TProductResponse> => {
  const productConfig = {
    configId: 'cobranded-page-conf',
    getProdConfigPath: '/getProdConfig',
  };
  const query = encodeURI(`?ProductConfigId=${productConfig.configId}`);
  const path = productConfig.getProdConfigPath;

  let data = {};
  try {
    const response = await api.get(path + query);
    data = response.data;
    return formatSuccess(data as TProductConfigResponse);
  } catch (error) {
    return {} as TProductResponse;
  }
};
